import { typographyTokens } from '../../theme/typographyTokens';
//TODO:  include test
import React, { useState, useCallback, useMemo } from 'react';
import Button from '../../components/Button';
import { transformQuillListToNested, nestedListStyles } from '../../utils/quillHtmlTransform';
import { Box, CircularProgress, Divider, Typography } from '@mui/material';
import {
  useGetKnockoutQuery,
  useSendKnockoutScreenAnswersMutation,
} from '../../services/knockoutSlice';
import { LoadingContainer } from '../../containers/LoadingContainer';
import StepperDots from '../../components/StepperDots';
import { useTheme } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';
import DataForm from './DataForm';
import { KnockoutScreenWithDataFields } from '../../../shared/types/Knockout';
import { ApmScreen } from './ApmScreen';
import { useUpdateSepMutation, useGetSepQuery } from '../../services/sepSlice';
import useMapData from '../../hooks/useMapData';
import ModalWidget from '../../components/ModalWidget/ModalWidget';
import CancelKnockoutSEP from '../../components/SepTable/CancelKnockoutSEP'
import { getWorkflowIcon } from '../../utils/workflowIconConfig';

const getReviewValue = (field: any) => {
  const selectedOptions = field.dataFieldOptions
    ?.filter((option: any) => option.selected)
    .map((option: any) => option.value);

  if (selectedOptions?.length) return selectedOptions.join(', ');
  if (typeof field.value === 'boolean') return field.value ? 'Yes' : 'No';
  return field.value === null || field.value === undefined || field.value === ''
    ? 'None'
    : String(field.value);
};

const Knockout = () => {
  const param = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  let sepId = 0;

  if (param.sepId !== undefined) sepId = +param.sepId;

  const {
    data: getKnockoutScreensRes,
    isSuccess,
    isLoading,
    error,
  } = useGetKnockoutQuery(sepId);
  const { data: sep } = useGetSepQuery(sepId);
  const [sendKnockoutScreenAnswers, { isLoading: isSaving }] =
    useSendKnockoutScreenAnswersMutation();
  const [currentScreenIdx, setCurrentScreenIdx] = useState(-1);
  const [apmScreenIdx, setApmScreenIdx] = useState(-2);
  const [updateSep] = useUpdateSepMutation();
  const [alternateContactScreen,setAlternateContactScreen] = useState(false)
  const [knockoutScreens, setKnockoutScreens] = React.useState<
    KnockoutScreenWithDataFields[] | null
  >(null);
  const [isSEPCancelModalOpen, setIsSEPCancelModalOpen] = useState<boolean>(false);
  const [isConfirming, setIsConfirming] = useState(false);

  const currentScreen =
    currentScreenIdx === -1 || !knockoutScreens
      ? null
      : knockoutScreens[currentScreenIdx];

  // Transform Quill HTML to proper nested structure
  const transformedScreenDescription = useMemo(
    () => transformQuillListToNested(currentScreen?.description ?? ''),
    [currentScreen?.description]
  );

  const goToOverview = useCallback(
    () => navigate(`/sep/${sepId}`, { replace: true }),
    [navigate, sepId]
  );

  let dataFields: any = [];

  const indexOfCurrentScreen = knockoutScreens?.findIndex(
    (screen: any, index: number) => //index !== apmScreenIdx && 
    screen?.id === currentScreen?.id
  );

  const handleBackButtonClick = () => {
    if (isConfirming) {
      setIsConfirming(false);
      return;
    }
    if ((alternateContactScreen && currentScreenIdx === 1) || (!alternateContactScreen && currentScreenIdx === 2)) {
      // We're on the first knockout screen, so redirect to the "Create screen" so the user can edit their SEP name & description

      navigate('/create', { state: { sepId, condition: 'edit' } });
    } else {
      // Go to previous knockout screen
      setCurrentScreenIdx(currentScreenIdx - 1);
    }
  };

  dataFields = useMemo(
    () =>{
     return( currentScreen &&
        [...currentScreen.knockoutScreenDataFields].sort(
          (a, b) => a.dataFieldLocation.order - b.dataFieldLocation.order
        ))
    }
    
     ,
    [currentScreen]
  );

  const knockout = true;
  const { data, setData, buttonValidation } = useMapData({
    dataFields,
    knockout,
  });

  const handleSubmit = async (e: any, apm?: any) => {
   // if (currentScreenIdx !== apmScreenIdx) {
      if(currentScreen?.name.includes("Name and Description")) {
      const userinputs: any = data && data?.find((item: any) =>  item.type = 'input')
      const userinputsDesc: any = data && data[1]?.value
      updateSep({ id: sepId, body: {name: userinputs?.value, description: userinputsDesc}}).unwrap();
      }
      if (currentScreen) {
        const filteredData = data?.filter((item: any) => item?.type !== 'textbox');
        const { data: updatedScreens } = (await sendKnockoutScreenAnswers({
          knockoutScreenID: currentScreen.id,
          dataFields: filteredData,
          finalize: false,
        })) as { data: KnockoutScreenWithDataFields[] };
        if (updatedScreens) {
          const firstIncompleteScreenIdx = updatedScreens.findIndex(
            (screen: any, index: number) => !screen.complete
          );
          const originalAltContactIndex = updatedScreens.findIndex(
            (screen: any, index: number) => screen.name.includes('Name and Description')
          );
          if (firstIncompleteScreenIdx >= 0) {
            setKnockoutScreens(reorder(updatedScreens));
            setData([]);
            // if(currentScreenIdx === (apmScreenIdx -1)) setCurrentScreenIdx(currentScreenIdx + 1)
            // else {
              if (firstIncompleteScreenIdx < originalAltContactIndex || originalAltContactIndex == -1)
                setCurrentScreenIdx(firstIncompleteScreenIdx + 2)
              else setCurrentScreenIdx(firstIncompleteScreenIdx + 1)
              if(firstIncompleteScreenIdx === 1 && currentScreen.name.includes('Name and Description')){
                setCurrentScreenIdx(currentScreenIdx + 1)
              }
              if(currentScreenIdx >= 2) {
                setCurrentScreenIdx(currentScreenIdx + 1)
              }
            // }
          } else {
            const reorderedScreens = reorder(updatedScreens);
            setKnockoutScreens(reorderedScreens);
            setCurrentScreenIdx(reorderedScreens.length - 1);
            setIsConfirming(true);
          }
        }
      }
    // } else {
    //   const apmID = apm === '' ? null : parseInt(apm);

    //   updateSep({
    //     id: sepId,
    //     body: { apmID: apmID },
    //   });
    //   setCurrentScreenIdx(currentScreenIdx + 1);
    // }
  };

  const handleConfirmSubmit = async () => {
    if (!currentScreen) return;
    await sendKnockoutScreenAnswers({
      knockoutScreenID: currentScreen.id,
      dataFields: [],
      finalize: true,
    }).unwrap();
    goToOverview();
  };

  const reorder = (array: any) => {
    const newArray: any = [];
    //let index = apmScreenIdx + 1;
    const IntialIndexValue = getKnockoutScreensRes?.some((screen: any)=> screen.name.includes('Name and Description')) && getKnockoutScreensRes?.some((sec: any) => sec.name.includes('alternate contact'))
    let index = IntialIndexValue ? 3 : 2
    // let index =2;
    array.forEach((item: any) => {
      if(item.name.includes('Name and Description')){
        newArray[1] = item;
      }else if(item.name.includes('alternate contact')){
        newArray[2] = item;
      }else{
        newArray[index] = item;
      index++;
      }
      
    });
    return newArray;
  };

  React.useEffect(() => {
    const alternateContactScreen = getKnockoutScreensRes?.findIndex((screen: any)=> screen.name.includes('Name and Description'))
    if (alternateContactScreen !== -1 )setAlternateContactScreen(true) //setApmScreenIdx(2)
    if (getKnockoutScreensRes) {
      setKnockoutScreens(reorder(getKnockoutScreensRes));
     // We've received the knockout screens for the first time when this component was mounted. Let's jump to the first incomplete screen.
      const firstIncompleteScreenIdx = getKnockoutScreensRes.findIndex(
        (screen: any, index: number) => !screen.complete
      );

      if (firstIncompleteScreenIdx >= 0) {
        location?.state?.slice(1) === 'create'
          ? setCurrentScreenIdx(1)
          : setCurrentScreenIdx(firstIncompleteScreenIdx + 2); // setCurrentScreenIdx(firstIncompleteScreenIdx + apmScreenIdx+ 1);
        if(firstIncompleteScreenIdx === 0) {
          setCurrentScreenIdx(1)
        }
        } else if (firstIncompleteScreenIdx === -1) {
        const reorderedScreens = reorder(getKnockoutScreensRes);
        setCurrentScreenIdx(reorderedScreens.length - 1)
        setIsConfirming(true)
      } else {
        // All of our knockout screens are complete. Redirect to SEP Overview.
        goToOverview();
      }
    }
  }, [getKnockoutScreensRes, goToOverview, location?.state]);

  if (isLoading || isSaving) {
    return (
      <LoadingContainer>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          width="100%"
        >
          <CircularProgress size={100} />
          <Typography variant="h5" sx={{ fontWeight: typographyTokens.fontWeights.bold, mt: 5 }}>
            Updating SEP...
          </Typography>
        </Box>
      </LoadingContainer>
    );
  } else if (
    getKnockoutScreensRes === error &&
    getKnockoutScreensRes === undefined
  ) {
    return (
      <LoadingContainer>
        <Typography>No SEP Found</Typography>
      </LoadingContainer>
    );
  // } else if (currentScreenIdx === apmScreenIdx) {
  //   return (
  //     <>
  //       <ApmScreen
  //         knockoutScreens={knockoutScreens}
  //         indexOfCurrentScreen={indexOfCurrentScreen}
  //         apmScreenIdx={apmScreenIdx}
  //         handleBackButtonClick={handleBackButtonClick}
  //         isSaving={isSaving}
  //         handleSubmit={handleSubmit}
  //         sepId={sepId}
  //       />
  //     </>
  //   );
  } else if (isSuccess && knockoutScreens && knockoutScreens.length > 0) {
    const visibleScreens = knockoutScreens.filter(Boolean);
    const getStepTitle = (screen: KnockoutScreenWithDataFields) =>
      screen.stepperTitle || screen.name;
    const currentStepTitle = currentScreen ? getStepTitle(currentScreen) : '';
    const questionnaireStepTitles = Array.from(new Set(visibleScreens.map(getStepTitle)));
    const stepTitles = [...questionnaireStepTitles, 'Review + Submit'];
    const currentStepIndex = isConfirming
      ? stepTitles.length - 1
      : questionnaireStepTitles.indexOf(currentStepTitle);
    const currentStepNumber = currentStepIndex + 1;
    const WorkflowIcon = getWorkflowIcon(sep?.workFlowType);
    const reviewFields = visibleScreens
      .flatMap((screen) => screen.knockoutScreenDataFields)
      .filter((field) => field.type !== 'textbox' && !['initiative name', 'initiative description'].includes(field.name.toLowerCase()));

    return (
      <Box sx={{ width: '100%', height: 'calc(100vh - 86px)', display: 'flex', flexDirection: 'column' }}>
        <StepperDots
          steps={stepTitles.length}
          activeStep={currentStepIndex}
          stepTitles={stepTitles}
        />
        <Divider sx={{ borderColor: '#8EC5F1' }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '30% 70%' }, flex: 1 }}>
          <Box sx={{ backgroundColor: '#EDF5FC', p: { xs: 3, md: 4 }, minHeight: { md: 440 }, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: '#2372B9' }}>
              <WorkflowIcon width={12} height={12} color="#2372B9" aria-label="Workflow icon" />
              <Typography sx={{ color: '#2372B9', fontSize: 10, fontWeight: typographyTokens.fontWeights.bold, letterSpacing: 0.6, textTransform: 'uppercase' }}>
                {sep?.workFlowType || 'Solution Enablement Process'}
              </Typography>
            </Box>
            <Typography sx={{ mt: 1.5, color: '#222', fontSize: 16, fontWeight: typographyTokens.fontWeights.regular }}>
              {isConfirming ? `Step ${currentStepNumber}: Review + Submit` : `Section ${currentStepNumber}: ${currentStepTitle}`}
            </Typography>
            {isConfirming ? (
              <Typography sx={{ mt: 2, color: '#646669', fontSize: 12, lineHeight: 1.5 }}>
                We want to understand if other review tasks are in scope for this request since that can impact who will be assigned to help with the review.
              </Typography>
            ) : (
              <>
                <Typography sx={{ mt: 2, color: '#222', fontSize: 14, fontWeight: typographyTokens.fontWeights.bold }}>
                  {currentScreen?.name}
                </Typography>
                <Box
                  className="knockout-description"
                  sx={{ mt: 1, color: '#646669', fontSize: 12, lineHeight: 1.5, overflowWrap: 'anywhere', wordBreak: 'break-word', ...nestedListStyles }}
                  dangerouslySetInnerHTML={{ __html: transformedScreenDescription }}
                />
              </>
            )}
            {!isConfirming && (
              <Typography sx={{ mt: 'auto', color: '#646669', fontSize: 10 }}>
                * denotes required field(s)
              </Typography>
            )}
          </Box>
          <Box sx={{ p: { xs: 2, md: 3 }, minWidth: 0 }}>
            {isConfirming ? (
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, columnGap: 5, rowGap: 3 }}>
                <Box sx={{ gridColumn: '1 / -1' }}>
                  <Typography sx={{ color: '#2372B9', fontSize: 14 }}>Initiative Name</Typography>
                  <Typography sx={{ mt: 0.5, color: '#222', fontSize: 14 }}>{sep?.name || 'None'}</Typography>
                </Box>
                <Box sx={{ gridColumn: '1 / -1' }}>
                  <Typography sx={{ color: '#2372B9', fontSize: 14 }}>Initiative Description</Typography>
                  <Box sx={{ mt: 0.5, color: '#222', fontSize: 14, overflowWrap: 'anywhere', ...nestedListStyles }} dangerouslySetInnerHTML={{ __html: transformQuillListToNested(sep?.description ?? 'None') }} />
                </Box>
                {reviewFields.map((field) => (
                  <Box key={field.id} sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: '#2372B9', fontSize: 14 }}>{field.name}</Typography>
                    <Typography sx={{ mt: 0.5, color: '#222', fontSize: 14, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                      {getReviewValue(field)}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <DataForm
                dataFields={dataFields}
                data={data}
                setData={setData}
                knockout
                currentScreen={currentScreen}
                alignment="left"
              />
            )}
          </Box>
        </Box>
        <Divider sx={{ backgroundColor: 'black' }} />
        {/** LOWER BUTTON CONTAINER */}
        <Box sx={{ diplay: 'flex', minWidth: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              mt: 3,
              mb: 3,
              justifyContent: 'space-between',
              px: 6,
            }}
          >
            <Button size="large" onClick={handleBackButtonClick}>
              <Box pr={1}>
                <i className="fa-regular fa-angle-left"></i>
              </Box>
              Back
            </Button>
            <ModalWidget
              isOpen={isSEPCancelModalOpen}
              title="Cancel SEP"
              children={
              <CancelKnockoutSEP sepId={sepId} setIsSEPCancelModalOpen={setIsSEPCancelModalOpen}/>
              }
              onClose={() => setIsSEPCancelModalOpen(false)}
            />
            <Box sx={{ display: 'flex', gap: 4 }}>
            <Button
              size="large"
              onClick={() => setIsSEPCancelModalOpen(true)}
            >
              Cancel
            </Button>

            <Button
              size="large"
              variant="contained"
              disabled={isSaving || (!isConfirming && buttonValidation)}
              onClick={isConfirming ? handleConfirmSubmit : handleSubmit}
            >
              {isConfirming ? "Submit" : "Continue"}
            </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return <>Something went wrong...</>;
  }
};
export default Knockout;
